var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/medpage_today_icon.svg"),"alt":"medpage today icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }